import { formatarData } from '../../../Funcoes/FormatarData';
import style from './PlanejamentoBody.module.css';

import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { FiEdit2 } from 'react-icons/fi';
import SortableTable from '../../Utils/SortableTable';

const PAGE_SIZE = 100;
const SCROLL_THRESHOLD = 40;

const PlanejamentoBody = ({ planejamento, editItem }) => {

    const lista = useMemo(
        () => (Array.isArray(planejamento) ? planejamento : []),
        [planejamento]
    );

    const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
    const tabelaRef = useRef(null);

    useEffect(() => {
        setVisibleCount(PAGE_SIZE);
        if (tabelaRef.current) {
            tabelaRef.current.scrollTop = 0;
        }
    }, [lista]);

    const loadMoreRows = useCallback(() => {
        setVisibleCount((prev) => {
            const total = lista.length;
            if (prev >= total) return prev;
            return Math.min(prev + PAGE_SIZE, total);
        });
    }, [lista.length]);

    const columns = useMemo(
        () => [
            {
                id: 'user',
                header: 'PLANEJADO POR',
                accessor: 'user',
                sortable: true,
            },
            {
                id: 'auditor',
                header: 'AUDITOR',
                accessor: 'auditor',
                sortable: true,
            },
            {
                id: 'auditado',
                header: 'AUDITADO',
                accessor: 'auditado',
                sortable: true,
            },
            {
                id: 'setor',
                header: 'SETOR',
                accessor: 'setor',
                sortable: true,
            },
            {
                id: 'data_planej',
                header: 'DATA PLANEJADA',
                accessor: 'data_planej',
                sortable: true,
                width: '160px',
                align: 'center',
                render: (value) => (value ? formatarData(value, true) : '-'),
            },
            {
                id: 'ultima_data',
                header: 'DATA REALIZADA',
                accessor: 'ultima_data',
                sortable: true,
                width: '160px',
                align: 'center',
                render: (value) => (value ? formatarData(value, true) : '-'),
            },
            {
                id: 'acoes',
                header: 'AÇÕES',
                sortable: false,
                width: '80px',
                align: 'center',
                render: (_, row) => (
                    <div className={style.acoesCelula}>
                        <button
                            type="button"
                            className={style.botaoAcao}
                            title="Editar planejamento"
                            onClick={(e) => {
                                e.stopPropagation();
                                editItem(row.id);
                            }}
                        >
                            <FiEdit2 size={14} />
                        </button>
                    </div>
                ),
            },
        ],
        [editItem]
    );

    return (
        <div className={style.container}>
            <div className={style.tableFlexFill}>
                <SortableTable
                    ref={tabelaRef}
                    columns={columns}
                    data={lista}
                    limit={visibleCount}
                    onScrollReachEnd={loadMoreRows}
                    scrollReachThreshold={SCROLL_THRESHOLD}
                    emptyText="Nenhum planejamento encontrado."
                    initialSort={{ key: 'data_planej', direction: 'desc' }}
                    getRowId={(row) => row.id}
                />
            </div>
        </div>
    );

};

export default PlanejamentoBody;
